import { jsx as _jsx } from "react/jsx-runtime";
import * as colors from '@mehilainen/mds-tokens/colors';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
// NOTE: Do not import these from lib root! Will cause circular deps
import { CircleTimes, CircleInfo, CheckCircle, ExclamationCircle, } from '../../icons';
const svgSeverityColor = {
    error: colors.Error500,
    warning: colors.Attention500,
    info: colors.Info500,
    success: colors.Success500,
};
export const getThemeAlert = (tokens) => {
    var _a, _b, _c, _d;
    return ({
        MuiAlert: {
            defaultProps: {
                iconMapping: {
                    error: _jsx(CircleTimes, {}),
                    warning: _jsx(ExclamationCircle, {}),
                    info: _jsx(CircleInfo, {}),
                    success: _jsx(CheckCircle, {}),
                },
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    fontSize: baseTypography.size[200].rem,
                    fontWeight: baseTypography.weight.Regular,
                    lineHeight: baseTypography.height.Large,
                    borderRadius: tokens.uiElementAlert.borderRadius,
                    border: tokens.uiElementAlert.border,
                    borderLeft: tokens.uiElementAlert.borderLeft,
                    padding: '12px',
                    alignItems: 'center',
                },
                icon: ({ ownerState }) => ({
                    padding: 0,
                    alignSelf: 'baseline',
                    '& > svg': {
                        height: '24px',
                        width: '24px',
                        color: ownerState.severity && svgSeverityColor[ownerState.severity],
                    },
                }),
                outlinedError: {
                    color: colors.Error600,
                    borderColor: (_a = tokens.uiElementAlert.borderErrorColor) !== null && _a !== void 0 ? _a : colors.Error500,
                    backgroundColor: colors.Error100,
                },
                outlinedWarning: {
                    color: colors.Attention600,
                    borderColor: (_b = tokens.uiElementAlert.borderWarningColor) !== null && _b !== void 0 ? _b : colors.Attention500,
                    backgroundColor: colors.Attention100,
                },
                outlinedInfo: {
                    color: colors.Info600,
                    borderColor: (_c = tokens.uiElementAlert.borderInfoColor) !== null && _c !== void 0 ? _c : colors.Info500,
                    backgroundColor: colors.Info100,
                },
                outlinedSuccess: {
                    color: colors.Success600,
                    borderColor: (_d = tokens.uiElementAlert.borderSuccessColor) !== null && _d !== void 0 ? _d : colors.Success500,
                    backgroundColor: colors.Success100,
                },
                message: {
                    padding: 0,
                },
                action: {
                    alignSelf: 'flex-start',
                    paddingTop: 0,
                    marginRight: 0,
                },
            },
        },
        MuiSnackbar: {
            defaultProps: {
                autoHideDuration: 3000,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
            },
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    fontSize: baseTypography.size[300].rem,
                    fontWeight: baseTypography.weight.Medium,
                    lineHeight: baseTypography.height.Large,
                    marginBottom: '4px',
                    marginTop: 0,
                },
            },
        },
    });
};
